import store from '@/store'
import { saleStatusHistory } from '@/config'
import commonUtil from '@/util/commonUtil'

export default {
  getSaleById(saleId) {
    const saleList = store.getters['Sale/getSaleListFromState']
    return saleList.find((v) => v.saleId === saleId)
  },
  // 販売データの合計金額の算出
  calcSaleAmountById(saleId) {
    const sale = this.getSaleById(saleId)
    return this.calcSaleAmount(sale)
  },
  calcSaleAmount(sale) {
    let totalTmp = sale.productMoves.reduce((sum, ele) => {
      return sum + ele.quantity * (ele.price * 100)
    }, 0)

    return (
      (totalTmp +
        Number(sale.consumptionTax8) * 100 +
        Number(sale.consumptionTax10) * 100 +
        Number(sale.comission) * 100 -
        Number(sale.discount) * 100) /
      100
    )
  },
  getSaleConfirmStatusList() {
    return commonUtil.getStatusHistoryIdNameList(
      saleStatusHistory.CONFIRM_STATUS,
      saleStatusHistory.STATUS_HISTORY_LABEL
    )
  },
  getSalePaymentStatusList() {
    return commonUtil.getStatusHistoryIdNameList(
      saleStatusHistory.PAYMENT_STATUS,
      saleStatusHistory.STATUS_HISTORY_LABEL
    )
  },
  getSaleShipStatusList() {
    return commonUtil.getStatusHistoryIdNameList(
      saleStatusHistory.SHIP_STATUS,
      saleStatusHistory.STATUS_HISTORY_LABEL
    )
  },
  getSaleCompleteStatusList() {
    return commonUtil.getStatusHistoryIdNameList(
      saleStatusHistory.COMPLETE_STATUS,
      saleStatusHistory.STATUS_HISTORY_LABEL
    )
  },
  getStatusListByType(type) {
    switch (type) {
      case saleStatusHistory.STATUS_HISTORY_TYPE_ID.CONFIRM:
        return this.getSaleConfirmStatusList()
      case saleStatusHistory.STATUS_HISTORY_TYPE_ID.PAYMENT:
        return this.getSalePaymentStatusList()
      case saleStatusHistory.STATUS_HISTORY_TYPE_ID.SHIP:
        return this.getSaleShipStatusList()
      case saleStatusHistory.STATUS_HISTORY_TYPE_ID.COMPLETE:
        return this.getSaleCompleteStatusList()
      case saleStatusHistory.STATUS_HISTORY_TYPE_ID.STATUS_NOTIFICATION:
        return this.getSaleNotificationStatusList
    }
  },
  getStatusHistoryTypeList() {
    const ret = []
    for (let key in saleStatusHistory.STATUS_HISTORY_TYPE_ID) {
      ret.push({
        id: saleStatusHistory.STATUS_HISTORY_TYPE_ID[key],
        name: saleStatusHistory.STATUS_HISTORY_TYPE_LABEL[key]
      })
    }
    return ret
  },
  getSaleNotificationStatusList() {
    return commonUtil.getStatusHistoryIdNameList(
      saleStatusHistory.CUSTOMER_ORDER_STATUS_HISTORY,
      saleStatusHistory.STATUS_HISTORY_LABEL
    )
  }
}
